import React, { useState, useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import stylesService from "../../styles/Molecules/ReportesServicio/service";
import ButtonComponent from "../../components/atoms/ButtonComponent";
import useWexClient from "../../hooks/Clients/wexClient,";
import SelectComponent from "../../components/atoms/Select";
import InputComponent from "../atoms/InputComponent";
import { useContext } from "react";
import { AuthContext } from "../../Auth/Context";

function SearchingAdvanced({}) {
  const { payload } = useContext(AuthContext);
  const { getServices, getListCRM } = useWexClient();
  const [selectedOptionRep, setSelectedOptionRep] = useState("");
  const [info, setInfo] = useState("");
  const [buttonColor, setButtonColor] = useState("#b5bac9");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [service, setService] = useState([]);
  const [selectedData, setSelectedData] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchDataFromAPI = async () => {
      try {
        const apiData = await getServices(payload._id);

        const serviceData = apiData.map((item) => ({
          id: item._id,
          name: item.name,
        }));

        if (serviceData.length > 0) {
          setService(serviceData);

          const storedOption = sessionStorage.getItem("SelectedOption");
          const initialOption = storedOption || serviceData[0]?.id;

          setSelectedOptionRep(initialOption);
          sessionStorage.setItem("SelectedOption", initialOption);

          const selectedOptionData = serviceData.find(
            (option) => option.id === initialOption
          );
          setSelectedData(selectedOptionData ? selectedOptionData.name : "");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataFromAPI();
  }, [payload._id]);

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
    setSelectedOptionRep(newValue);

    const selectedOptionData = service.find(
      (option) => option.name === newValue
    );

    if (selectedOptionData) {
      updateButtonState(selectedOptionData.id, info);
      updateCRM(selectedOptionData.id);
      setSelectedData(selectedOptionData.name);
    }
  };

  const updateCRM = async (selectedId) => {
    try {
      const response = await getListCRM(selectedId);
      setData(response);
    } catch (error) {
      console.error(error);
    }
  };

  const [inputValues, setInputValues] = useState(new Array(data.length).fill('')); 

  const handleInputChange = (newValue, index) => {
    const newData = [...data];
    newData[index].value = newValue;
    setData(newData);

    const newInputValues = [...inputValues];
    newInputValues[index] = newValue;
    setInputValues(newInputValues);
  };

  
  const updateButtonState = (selectedValue, inputValue) => {
    const isSelectValid = selectedValue !== "0";
    const isInputValid = inputValue.trim() !== "";

    const shouldCheckInput = !service.find(
      (option) => option._id === selectedValue
    )?.status;

    const isValid = shouldCheckInput
      ? isSelectValid
      : isSelectValid && isInputValid;

    setIsButtonDisabled(!isValid);
    setButtonColor(isValid ? "white" : "#b5bac9");
  };

  const handleClickSearch = () => {
    if (isButtonDisabled) {
      alert("Hay campos vacíos. Por favor, completa la información.");
    } else {
      alert("Funciona el evento 2");
    }
  };

  return (
    <Stack sx={{ width: "100%" }}>
      <Stack sx={{ ...stylesService.stack }}>
        <SelectComponent
          colorLabel="white"
          fontWeight="bold"
          fontSizeInput="1.5rem"
          onChange={handleSelectChange}
          value={selectedOptionRep}
          valueSelect="name"
          options={service}
          label="Servicio"
          textColor="gray"
          backgroundColor="white"
        />
      </Stack>

      <Stack sx={{ width: "100%" }}>
        <Stack>
          <Typography
            color="#023E8A"
            fontSize="2rem"
            fontWeight="bold"
            marginTop="2rem"
          >
            Campos de Búsqueda
          </Typography>

          {data !== null &&
            data.map((item, index) => (
              <Stack key={index}>
                <Typography
                  color="white"
                  fontSize="1.5rem"
                  fontWeight="bold"
                  marginTop="1rem"
                >
                  {item.title}
                </Typography>
                <Stack
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    border: "none",
                  }}
                >
                  <InputComponent
                    label={
                      item.value ? " " : `Aquí va un ejemplo de ${item.title}`
                    }
                    value={item.value}
                    onChange={(e) => handleInputChange(e, index)} //crear constante con los datos de data dentro de handleinputchange
                    //data en la posicion de index
                    fullWidth
                    backgroundColor="white"
                  />
                </Stack>
              </Stack>
            ))}
        </Stack>
      </Stack>

      <Stack sx={{ width: "6rem", marginTop: "1rem", marginLeft: "28rem" }}>
        <ButtonComponent
          label="Buscar"
          onClick={handleClickSearch}
          backgroundColor={buttonColor}
          disabled={isButtonDisabled}
          color="black"
        />
      </Stack>
    </Stack>
  );
}
export default SearchingAdvanced;
